<template>
  <div class="Index">
    <NavComponent class="content-container"></NavComponent>
    <div>
        <Swiper v-if="slideArray.length > 0" class="swiper-container" :options="swiperOption" ref="backSwiper">
            <Swiper-slide  class="slid-container" v-for="(slideItem , index) in slideArray" :key="index">
                <div  class="slide" v-bind:style="{background:'url(' + slideItem.image + ') no-repeat center'}">
                </div>
            </Swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </Swiper>
    </div>
    <div class="main content-container">
      <ul>
        <li><img :src="main_img"/><h3>套餐详细</h3><span></span><div class="button">Read More</div></li>
        <li><img :src="main_img"/><h3>套餐详细</h3><span></span><div class="button">Read More</div></li>
        <li><img :src="main_img"/><h3>套餐详细</h3><span></span><div class="button">Read More</div></li>
        <li><img :src="main_img"/><h3>套餐详细</h3><span></span><div class="button">Read More</div></li>
      </ul>
    </div>
    <div class="bg">
      <div class="content-container content">
        <h3>我们的优势<span>Our Advantages</span></h3>
        <ul>
          <li>20<p>20年英国院校深度合作经验</p></li>
          <li>20<p>20年英国院校深度合作经验</p></li>
          <li>20<p>20年英国院校深度合作经验</p></li>
          <li>20<p>20年英国院校深度合作经验</p></li>
          <li>20<p>20年英国院校深度合作经验</p></li>
          <li style="border:none">20<p>20年英国院校深度合作经验</p></li>
        </ul>
      </div>
    </div>
    <div class="success content-container">
        <div class="title">成功案例</div>
        <div class="cont-box">
          <img class="arrow" @click="goLeft" :src="arrow_left" />
          <div class="box">
            <ul ref="ul">
              <li v-for="(item,index) in successList" :key="index">{{item.name}}</li>
            </ul>
          </div>
        <img class="arrow" @click="goRight" :src="arrow_right" />
        </div>
    </div>
    <div class="service content-container">
      <div class="title">英国留学服务全流程</div>
      <ul>
        <li v-for="(item,index) in list1" :key="index">
          <div class="yuan"></div>
          <div class="right">{{item.name}}<p>{{item.p}}</p></div>
        </li>
      </ul>
      <img class="line" :src="line_img"/>
      <ul>
        <li v-for="(item,index) in list2" :key="index">
          <div class="yuan"><img src=""/></div>
          <div class="right">{{item.name}}<p>{{item.p}}</p></div>
        </li>
      </ul>
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
// @ is an alias to /src
import NavComponent from '@components/NavComponent'
import FooterComponent from '@components/FooterComponent'
import { Swiper, SwiperSlide } from "vue-awesome-swiper"
import main_img from '../assets/image/main.jpg'
import 'swiper/css/swiper.css'
import line_img from '../assets/image/line.jpg'
import arrow_left from '../assets/image/arrow-left.png'
import arrow_right from '../assets/image/arrow-right.png'

export default {
  name: 'Index',
  components: {
    NavComponent,
    Swiper,SwiperSlide,
    FooterComponent
  },
  data(){
    return {
      main_img,line_img,
      arrow_left,arrow_right,
      swiperOption: {
        loop: true,   
        grabCursor: true,
        autoplay: {//自动播放
          delay: 6000,
          disableOnInteraction: false
        },
      },
      speed:0,
      successList:[
        {name:1},
        {name:2},
        {name:3},
        {name:4},
        {name:5},
        {name:6},
        {name:7},
        {name:8},
      ],
      list1:[
        {name:'咨询签约',p:'国内客服发出第一封问候信，并提供监督投诉电话'},
        {name:'咨询签约',p:'国内客服发出第一封问候信，并提供监督投诉电话'},
        {name:'咨询签约',p:'国内客服发出第一封问候信，并提供监督投诉电话'},
      ],
      list2:[
        {name:'咨询签约',p:'国内客服发出第一封问候信，并提供监督投诉电话'},
        {name:'咨询签约',p:'国内客服发出第一封问候信，并提供监督投诉电话'},
        {name:'咨询签约',p:'国内客服发出第一封问候信，并提供监督投诉电话'},
      ],
      slideArray:[
        {image:'http://cdn.hanlandglobal.com/sp1.jpg'},
        {image:'http://cdn.hanlandglobal.com/sp2.jpg'},
      ]
    }
  },
  mounted(){
    this.$refs.ul.style.width = this.successList.length*276 + 'px'
  },
  methods:{
    goLeft(){  
      if(this.speed <= (this.successList.length - 4)*-276){
          return
      }
      this.speed = this.speed - 276
      console.log(this.speed)
      this.$refs.ul.style.transform = 'translate('+ this.speed +'px)';
      this.$refs.ul.style.transitionDuration =  '0.5s'
    },
    goRight(){
      if(this.speed >= 0){
          return
      }
      this.speed = this.speed + 276
      console.log(this.speed)
      this.$refs.ul.style.transform = 'translate('+ this.speed +'px)';
      this.$refs.ul.style.transitionDuration =  '0.5s'
    }
  }

}
</script>
<style lang='scss' scoped>
.background-swiper-container{
    position: relative;
}
.slide{
  display: block;
  height: 76vh;
}
.bg{
    width: 100%;
    height: 235px;
    background: url('../assets/image/bg.png');
    background-size:100% 100%;
}
.content{
  color: #fff;
}
.content{
    text-align: left;
  h3{
    font-size: 30px;
    margin-top: 30px;
    span{
        font-size: 14px;
        color: #bbb;
        margin-left: 7px;
    }
  }
  ul{
    display: flex;
    text-align: center;
    margin-top:20px;
    li{
      border-right: 1px solid #fff;
      font-size: 56px;
      padding:0 20px;
      p{
        font-size: 14px;
        line-height: 20px;
        color: hsla(0, 0%, 100%, .9);
      }
    }
  }
}
.main{
    height: 180px;
  ul{
    display: flex;
    position: absolute;
    bottom: 0px;
    z-index: 999;
    li{
      flex: 25%;
      padding:30px;
      background: #fff;
      img{
        width: 233px;
        height: 143px;
        border-radius: 10px;
      }
      h3{
        text-align: left;
        color: #000;
        margin:25px 0 18px
      }
      span{
        display: block;
        width: 66px;
        border-top:2px solid #c5a65d;
      }
    }
  }
}
.button{
  width: 120px;
  height: 36px;
  margin: 15px auto 0;
  color: #c5a65d;
  border:1px solid #c5a65d;
  text-align: center;
  line-height: 36px;
  font-size: 14px;
}
.title{
  font-size: 30px;
  text-align: left;
  font-weight: normal;
  color: #073a78;
  margin: 66px auto 45px;
}
.yuan{
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background-color: #e6e6e6;
}
.right{
  width: 210px;
  color: #010101;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  padding: 10px 0 20px 10px;
  p{
    font-size: 14px;
    color: #555555;
    line-height: 21px;
    margin-top:16px;
  }
}
.line{
  margin-bottom: 30px;
}
.success{
  .cont-box{
    display: flex;
  }
  .box{
    width: 1200px;
    // overflow-x:scroll;
    overflow: hidden;
  }
  ul{
    width: 1660px;
    display: flex;
    // overflow: hidden;
  }
  li{
    width: 255px;
    height: 400px;
    text-align: center;
    vertical-align: middle;
    margin-right: 20px;
    float: left;
    border: 1px solid #d5d4d4;
    position: relative;
    z-index: 1;
    box-shadow: 1px 6px 3px -2px #b5b5b5;
  }
}
.service{
  ul{
    display: flex;
    li{
      width: 400px;
      height: 150px;
      display: flex;
    }
  }
}
.arrow{
  width: 29px;
  height: 57px;
  margin:190px 20px 0 0;
  cursor: pointer;
}
</style>
